import React from 'react'
import ProgressiveImage from '../../progressive-image/progressive-image'

import styles from '../social.css'

const SocialChannel = ({
  image,
  link,
  text,
  fluid,
  baseImageUrl = 'https://localhost.media.livenationinternational.com/lincsmedia',
}) => {
  const listItemClassName = fluid
    ? styles['list__item--fluid']
    : styles['list__item']
  return (
    <li className={listItemClassName}>
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className={styles['link']}
      >
        <ProgressiveImage
          alt={text}
          src={`${baseImageUrl}${image}`}
          className={styles['icon']}
        />
      </a>
    </li>
  )
}

export default SocialChannel
